import React, { useState, useEffect, useCallback } from 'react';
import GoogleMapReact from 'google-map-react';

const AddressPicker = ({ lat, lng, fetchAddressOnPointerChange, setFormCoordinates }) => {
  const [center, setCenter] = useState({ lat, lng });
  const [marker, setMarker] = useState({ lat, lng });
  const [zoom, setZoom] = useState(18);
  const [hasLocationPermission, setHasLocationPermission] = useState(false);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    // Check location permission on component mount
    navigator.permissions.query({ name: 'geolocation' })
      .then((result) => {
        setHasLocationPermission(result.state === 'granted');
        
        // Listen for permission changes
        result.addEventListener('change', () => {
          setHasLocationPermission(result.state === 'granted');
        });
      });
  }, []);

  const updateCoordinates = useCallback(
    (newLat, newLng) => {
      setCenter({ lat: newLat, lng: newLng });
      setMarker({ lat: newLat, lng: newLng });
      setFormCoordinates(newLat, newLng);  
      fetchAddressOnPointerChange(newLat, newLng); 
    },
    [setFormCoordinates, fetchAddressOnPointerChange]
  );

  const handleMarkerDrag = (event) => {
    const lat = event.center.lat();
    const lng = event.center.lng();
    updateCoordinates(lat, lng);
  };

  useEffect(() => {
    const removeMapUIElements = () => {
      const elementsToHide = [
        '.gm-bundled-control',
        '.gmnoprint a',
        '.gmnoprint span',
        '.gm-style-cc'
      ];

      elementsToHide.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => element.style.display = 'none');
      });
    };

    removeMapUIElements();
    const intervalId = setInterval(removeMapUIElements, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const createMapOptions = () => ({
    gestureHandling: isMobile ? 'greedy' : 'cooperative', 
    mapTypeId: 'satellite',
    rotateControl: false,
    tilt: 0,
    fullscreenControl: false,
    disableDefaultUI: true,
  });

  const handleRecenter = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          updateCoordinates(latitude, longitude);
          setHasLocationPermission(true);
        },
        (error) => {
          console.error("Error getting location: ", error);
          setHasLocationPermission(false);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <div style={{ position: 'relative', height: '400px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyB95JaT-LA1RWVOaeBvuTU_Yf8eIsynnNc" }}
        center={center}
        zoom={zoom}
        defaultZoom={18}
        onZoomAnimationEnd={(newZoom) => setZoom(newZoom)}
        options={createMapOptions()}
        onClick={({ lat, lng }) => updateCoordinates(lat, lng)}  
        onDragEnd={handleMarkerDrag}
        yesIWantToUseGoogleMapApiInternals
      >
        <Marker
          lat={marker.lat}
          lng={marker.lng}
          draggable={true}
          onDragEnd={handleMarkerDrag}
          hasPermission={hasLocationPermission}
        />
      </GoogleMapReact>

      <button 
        onClick={handleRecenter} 
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 10,
          padding: '8px 12px',
          backgroundColor: '#4285F4',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Recenter
      </button>
    </div>
  );
};

const Marker = ({ lat, lng, draggable, onDragEnd, hasPermission }) => (
  <div
    lat={lat}
    lng={lng}
    draggable={draggable}
    style={{
      cursor: 'grabbing',
      transform: 'translate(-50%, -50%)',
      zIndex: 1,
      position: 'absolute',
    }}
    onMouseUp={onDragEnd}
  >
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke={hasPermission ? "#22C55E" : "#EF4444"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" fill={hasPermission ? "rgba(34, 197, 94, 0.7)" : "rgba(239, 68, 68, 0.7)"} />
      <circle cx="12" cy="12" r="5" fill="#fff" />
    </svg>
  </div>
);

export default AddressPicker;